// extracted by mini-css-extract-plugin
export var center = "_f-2";
export var clickableRow = "_f-5";
export var expandedRow = "_f-7";
export var hoverable = "_f-4";
export var left = "_f-1";
export var right = "_f-3";
export var row = "_f-0";
export var selectedRow = "_f-6";
export var summaryRow = "_f-8";